<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">                
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to reports list" @click="$router.push('/projects')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="projects" pageId="project-reports" color="white"></help-link>
                </v-toolbar>
            </v-card>
            <v-layout row wrap :style="isMobile?'padding-top:5px':'padding:5px'">
                <v-flex xs12 sm3 v-for="(item,index) in project_reports" :key="index">
                    <v-hover>
                        <v-card slot-scope="{hover}" :class="isMobile?`menu-card-mobile elevation-${hover?3:1}`:`menu-card elevation-${hover?3:1}`">
                            <v-toolbar flat height="40">
                                <span class="body-2 page-header" @click="navigateToPage(item.pagePath)">
                                    {{item.pageName}}
                                </span>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text xs12 class="caption grey--text menu-body" @click="navigateToPage(item.pagePath)">
                                <v-layout row wrap>
                                    <v-flex xs3>
                                        <v-icon size="40" class="mr-1" :color="hover?'primary':''" :style="isMobile?'margin-left:15px;':'margin-left:5px;'">{{item.pageIcon}}</v-icon>
                                    </v-flex>
                                    <v-flex xs9>
                                        <div class="menu-description">
                                            {{item.pageDescription}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout> 
</template>

<script>
export default {     
    name: 'ProjectReports',
    metaInfo: {
        title: 'Project Reports',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Project Reports' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
      return {
        error: false,
        errorMessage: '',
        loading: false,
        project_reports: [
            {
                pageName: 'Project Summary Report',
                pageDescription: 'Projects overview, monthly project charges and project chages distribution',
                pagePath: '/projects/reports/summary',
                pageIcon: 'view_timeline'
            },
            {
                pageName: 'Employee Task Charges Report',
                pageDescription: 'Highlights individual employee contributions to tasks and projects over a given period.',
                pagePath: '/projects/reports/employees',
                pageIcon: 'person_search'
            }
        ]
      }
    },
    methods: {
        navigateToPage(path) {
            this.$router.push(path)
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'Project Reports',
            headerPageTitle: ''
        })
    },
    computed: { 
        isMobile() {
            return window.innerWidth < 600
        },
    },
}
</script>
<style scoped>
.menu-description {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: -10px;
}
.menu-body:hover {
    cursor: pointer;
    text-decoration: underline;
}
.menu-card {
    height: 130px;
    overflow: hidden; 
    margin: 2px 2px 0px 2px; 
    border-radius: 5px
}
.menu-card-mobile {
    height: 110px;
    overflow: hidden; 
    margin: 3px 5px 0px 5px; 
    border-radius: 5px;
}
.page-header:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>